// https://github.com/yangg/scrolling-element
import 'scrolling-element'

// from:https://github.com/jserz/js_piece/blob/master/DOM/ChildNode/remove()/remove().md
(function (arr) {
    arr.forEach(function (item) {
      if (item.hasOwnProperty('remove')) {
        return;
      }
      Object.defineProperty(item, 'remove', {
        configurable: true,
        enumerable: true,
        writable: true,
        value: function remove() {
          if (this.parentNode !== null)
            this.parentNode.removeChild(this);
        }
      });
    });
  })([Element.prototype, CharacterData.prototype, DocumentType.prototype]);

  // Overwrites native 'firstElementChild' prototype.
// Adds Document & DocumentFragment support for IE9 & Safari.
// Returns array instead of HTMLCollection.
// https://developer.mozilla.org/en-US/docs/Web/API/ParentNode/firstElementChild
(function(constructor) {
  if (constructor &&
      constructor.prototype &&
      constructor.prototype.firstElementChild == null) {
      Object.defineProperty(constructor.prototype, 'firstElementChild', {
          get: function() {
              var node, nodes = this.childNodes, i = 0;
              while (node = nodes[i++]) {
                  if (node.nodeType === 1) {
                      return node;
                  }
              }
              return null;
          }
      });
  }
})(window.Node || window.Element);
